module.exports = __webpack_public_path__ + "img/delete.08da9156.svg";